var configText;
var Language = "CHN";//"EN";

if(Language === "CHN"){
  configText = {
    title:"轻橙",
    menu:"菜单",
    startToCreate:"开始创作",
    gamesListHeader:"我的轻橙作品",
    status:"状态",
    runs:"运行量",
    wordCount:"字数",
    createTime:"创建时间",
    createNewStory:"创建新故事",
    toolName:"轻橙制作工具",
    createChat:["创建对话模式","创建视觉模式","创建情景故事"],
    gamesManage:"作品管理"
  }
}else if(Language === "EN"){
  configText = {
    title:"org mobile tool",
    menu:"menu",
    startToCreate:"start to create",
    gamesListHeader:"my stories",
    status:"status",
    runs:"runs",
    wordCount:"word count",
    createTime:"create time",
    createNewStory:"create new story",
    toolName:"org tool by mobile",
    createChat:["create chat story","create vision story","create scene story"],
    gamesManage:"stories manage"
  }
}

export default configText;




// WEBPACK FOOTER //
// ./src/config/ConfigText.js